import {combineReducers} from "redux";
import request from "./product/request";
import create from "./product/create";

export default combineReducers({request, create});
